<div *ngIf="carregando()" class="loading-overlay" [class.loading-overlay-modal]="modoModal"
     role="status" aria-label="Carregando impressão de vendas">
    <app-loading-indicator></app-loading-indicator>
</div>
<div class="print-layout" [class.modo-modal]="modoModal">
    <aside class="print-controls-shell no-print">
        <header class="ds-page-header">
            <div class="ds-page-header-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M6 9V2h12v7"></path>
                    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                    <rect x="6" y="14" width="12" height="8"></rect>
                </svg>
            </div>
            <div class="ds-page-header-copy">
                <h1 class="ds-page-title">Impressão de Vendas</h1>
                <p class="ds-page-subtitle">Página de impressão</p>
            </div>

            <div class="ds-page-actions print-hero-controls" aria-label="Parametros de impressao" *ngIf="parametros">
                <fieldset>
                    <legend>Conteudo</legend>
                    <label>
                        <input type="checkbox" [(ngModel)]="params.IMP_DESC">
                        Descr.
                    </label>
                    <label>
                        <input type="checkbox" [(ngModel)]="params.IMP_FABR">
                        Fabri.
                    </label>
                    <label>
                        <input type="checkbox" [(ngModel)]="params.IMP_CD">
                        CD
                    </label>
                    <label>
                        <input type="checkbox" [(ngModel)]="params.IMP_PN">
                        PNs
                    </label>
                    <label>
                        <input type="checkbox" [(ngModel)]="params.IMP_FAT">
                        Fat
                    </label>
                    <label>
                        <input type="checkbox" [(ngModel)]="params.IMP_ENT">
                        Ent.
                    </label>
                    <label>
                        <input type="checkbox" [(ngModel)]="params.IMP_IPI">
                        IPI
                    </label>
                    <label>
                        <input type="checkbox" [(ngModel)]="params.IMP_ST">
                        ST
                    </label>
                </fieldset>

                <fieldset>
                    <legend>Valores</legend>
                    <label>
                        <input type="checkbox" [(ngModel)]="params.IMP_VLR">
                        Valores
                    </label>
                    <label>
                        <input type="checkbox" [(ngModel)]="params.IMP_DOL">
                        Dolar
                    </label>
                    <label>
                        <input type="checkbox" [(ngModel)]="params.IMP_TOT">
                        Total
                    </label>
                    <label>
                        <input type="checkbox" [(ngModel)]="params.IMP_DES">
                        Desc.
                    </label>
                    <label>
                        <input type="radio" name="moedaValores" [(ngModel)]="params.IMP_MOEDA" value="BRL">
                        R$
                    </label>
                    <label>
                        <input type="radio" name="moedaValores" [(ngModel)]="params.IMP_MOEDA" value="USD">
                        U$
                    </label>
                </fieldset>

                <fieldset>
                    <legend>COR</legend>
                    <label>
                        <input type="checkbox" [(ngModel)]="impressaoPB" (ngModelChange)="aplicarModoImpressao()">
                        P/B
                    </label>
                </fieldset>

                <div class="print-hero-actions">
                    <button
                            type="button"
                            class="secondary"
                            (click)="imprimir()">
                        Imprimir
                    </button>

                    <button
                            type="button"
                            (click)="gerarPdf()">
                        Gerar PDF
                    </button>
                </div>
            </div>
        </header>

        <div class="print-sub-actions" *ngIf="!aguardandoSelecaoVenda">
            <div class="print-zoom-controls">
                <button
                        type="button"
                        class="print-zoom-button"
                        (click)="zoomVenda('+')"
                        title="Aumentar zoom">
                    +
                </button>

                <button
                        type="button"
                        class="print-zoom-button"
                        (click)="zoomVenda('-')"
                        title="Diminuir zoom">
                    -
                </button>

                <button
                        type="button"
                        class="print-zoom-button print-zoom-toggle"
                        (click)="alternarZoomVenda()"
                        [title]="vendaZoomAtual >= 1.6
                    ? 'Voltar ao zoom padrao'
                    : 'Aplicar zoom maximo'">

                    <lucide-angular
                            [img]="vendaZoomAtual >= 1.6 ? ZoomOut : ZoomIn"
                            size="18">
                    </lucide-angular>
                </button>
            </div>

            <div class="print-result-navigation" *ngIf="possuiNavegacaoVendas">
                <button
                        type="button"
                        class="print-navigation-button"
                        (click)="vendaAnterior()"
                        [disabled]="!podeNavegarAnterior"
                        title="Abrir venda anterior">
                    Anterior
                </button>

                <span class="print-navigation-position">
            {{ indiceNotaNavegacao + 1 }} de {{ notasNavegacao.length }}
        </span>

                <button
                        type="button"
                        class="print-navigation-button"
                        (click)="proximaVenda()"
                        [disabled]="!podeNavegarProxima"
                        title="Abrir próxima venda">
                    Próxima
                </button>
            </div>

            <button
                    type="button"
                    class="print-return-button"
                    (click)="acaoVoltarOuFechar()">
                {{ modoModal ? 'Fechar' : 'Voltar' }}
            </button>
        </div>
    </aside>

    <main class="print-content-shell">

        <div class="print-scroll-navigation no-print" *ngIf="modoModal">
            <button
                    type="button"
                    class="print-zoom-button"
                    *ngIf="mostrarIrTopo"
                    (click)="irParaTopoImpressao()"
                    title="Ir para o topo da impressao"
                    aria-label="Ir para o topo da impressao">
                &uarr;
            </button>
            <button
                    type="button"
                    class="print-zoom-button"
                    *ngIf="mostrarIrFinal"
                    (click)="irParaFinalImpressao()"
                    title="Ir para o final da impressao"
                    aria-label="Ir para o final da impressao">
                &darr;
            </button>
        </div>

        <section
                class="quick-sale-search no-print"
                *ngIf="aguardandoSelecaoVenda">

            <div class="quick-sale-title">
                Buscar orcamento de venda
            </div>

            <div class="quick-sale-filters">
                <div class="quick-sale-field">
                    <input
                            type="text"
                            autocomplete="off"
                            placeholder="Digite o CNPJ ou Nome do cliente..."
                            [(ngModel)]="buscaClienteTexto"
                            (input)="agendarBuscaClientes()"
                            (keyup.enter)="buscarClientes()"
                            (focus)="buscaClienteTexto.trim().length >= 2 && (dropdownClientesAberto = true)">

                    <div
                            class="quick-sale-dropdown"
                            *ngIf="dropdownClientesAberto">

                        <button
                                type="button"
                                class="quick-sale-option"
                                *ngFor="let cliente of clientesBusca"
                                (click)="selecionarClienteBusca(cliente)">

                            {{ labelClienteBusca(cliente) }}
                        </button>

                        <div
                                class="quick-sale-empty"
                                *ngIf="!clientesBusca.length && buscaMensagem">

                            {{ buscaMensagem }}
                        </div>
                    </div>
                </div>

                <label class="quick-sale-date">
                    <span>Dt. inicial</span>
                    <input
                            type="date"
                            [(ngModel)]="buscaDataInicial">
                </label>

                <label class="quick-sale-date">
                    <span>Dt. final</span>
                    <input
                            type="date"
                            [(ngModel)]="buscaDataFinal">
                </label>

                <button
                        type="button"
                        class="quick-sale-search-button"
                        (click)="buscarFiltroImpressao()">
                    Buscar
                </button>
            </div>

            <div
                    class="quick-sale-selected"
                    *ngIf="clienteSelecionadoBusca">

                <strong>
                    {{ labelClienteBusca(clienteSelecionadoBusca) }}
                </strong>

                <span>
            Ultimas 10 vendas por ordem de criacao decrescente
        </span>
            </div>

            <div
                    class="quick-sale-notes"
                    *ngIf="notasCliente.length">

                <div
                        class="quick-sale-note quick-sale-note-header"
                        aria-hidden="true">

                    <span>No UNICO</span>
                    <span>VENDA</span>
                    <span>DATA</span>
                    <span>STATUS</span>
                    <span>PREFIXO</span>
                    <span>COM</span>
                    <span>VALOR U$</span>
                    <span>VALOR R$</span>
                </div>

                <button
                        type="button"
                        class="quick-sale-note"
                        *ngFor="let nota of notasCliente"
                        (click)="selecionarNotaBusca(nota)">

            <span class="note-mono note-nunota">
                {{ notaNunotaBusca(nota) }}
            </span>

                    <span class="note-mono note-venda">
                {{ notaVendaBusca(nota) }}
            </span>

                    <span class="note-date">
                {{ notaDataBusca(nota) }}
            </span>

                    <span class="note-status">
                {{ notaStatusBusca(nota) }}
            </span>

                    <span class="note-prefixo">
                {{ notaPrefixoBusca(nota) || '-' }}
            </span>

                    <span class="note-com">
                {{ notaCertificadoBusca(nota) || '-' }}
            </span>

                    <span class="note-value">
                {{ notaValorDolarBusca(nota) }}
            </span>

                    <span class="note-value">
                {{ notaValorBusca(nota) }}
            </span>
                </button>
            </div>

            <div
                    class="quick-sale-empty quick-sale-message"
                    *ngIf="!dropdownClientesAberto && !notasCliente.length && buscaMensagem">

                {{ buscaMensagem }}
            </div>
        </section>

        <ng-container *ngIf="!aguardandoSelecaoVenda">
            <div class="print-pages source-pages" aria-hidden="true">

                <main
                        class="page"
                        [class.impressao-pb-page]="impressaoPB"
                        *ngFor="let documento of documentos; let pagina = index"
                        [ngStyle]="pageA4Style()">

                    <section class="report">

                        <header class="header-grid">
                            <div class="brand">
                                <img
                                        class="logo"
                                        src="/assets/logo_global.png"
                                        alt="Logo">

                                <div class="company-line">
                                    <div>
                                        <strong>CNPJ:</strong>
                                        <span>
                                    {{ value(documento.data, 'CNPJEMP') }}
                                </span>
                                    </div>
                                </div>
                            </div>

                            <div class="system-box">
                                <span>Empresa</span>
                                <strong>
                                    {{ value(documento.data, 'CODEMP') }}
                                </strong>

                                <span>Usuario</span>
                                <strong>
                                    {{ usuarioLogado() }}
                                </strong>

                                <span>Data / Hora</span>
                                <strong>
                                    {{ dataHoraCabecalho(documento.data) }}
                                </strong>
                            </div>
                        </header>

                        <section class="doc-title">
                            <div class="quote-number">
                                <span>Orcamento</span>
                                <strong>
                                    {{ nunotaFormatado(documento.data) }}
                                </strong>
                            </div>

                            <div class="quote-heading">
                                <h1>
                                    {{ value(documento.data, 'DESCROPER').toUpperCase() }}
                                </h1>
                            </div>

                            <div class="quote-id">
                                <svg *ngIf="codigoBarrasNunota(documento.data) as codigo"
                                     class="barcode" xmlns="http://www.w3.org/2000/svg"
                                     [attr.viewBox]="codigo.viewBox" preserveAspectRatio="none"
                                     role="img" [attr.aria-label]="'NUNOTA ' + codigo.valor">
                                    <title>NUNOTA {{ codigo.valor }}</title>
                                    <rect width="100%" height="100%" fill="#fff" />
                                    <path [attr.d]="codigo.caminho" fill="#000" />
                                </svg>
                            </div>
                        </section>

                        <section
                                class="section-block"
                                *ngIf="false"
                                style="padding-bottom: 20px">

                            <div class="section-title">
                                CLIENTE A SER FATURADO
                            </div>

                            <div style="min-height: 10px;"></div>

                            <div class="info-grid-nom">
                                <div>Cliente:</div>
                                <div class="strong">
                                    {{ value(documento.data, 'NOMEPARC') }}
                                </div>

                                <div>e-mail:</div>
                                <div class="strong">
                                    {{
                                    documento.data?.EMAILPARC
                                    ? value(documento.data, 'EMAILPARC')
                                    : 'NÃO INFORMADO'
                                    }}
                                </div>
                            </div>

                            <div class="info-grid-doc">
                                <div>CPF/CNPJ:</div>
                                <div class="strong">
                                    {{ value(documento.data, 'CNPJ') }}
                                </div>

                                <div>IE:</div>
                                <div class="strong">
                                    {{
                                    documento.data?.INSCMUN
                                    ? value(documento.data, 'INSCMUN')
                                    : '----'
                                    }}
                                </div>
                            </div>

                            <div class="info-grid-end">
                                <div>Endereço:</div>
                                <div class="strong">
                                    {{ value(documento.data, 'NOMEEND') }}
                                </div>

                                <div>Fone:</div>
                                <div class="strong">
                                    {{ maskTelefone(value(documento.data, 'TELPARC')) }}
                                </div>
                            </div>

                            <div class="info-grid-ctt">
                                <div>Bairro:</div>
                                {{ value(documento.data, 'NOMEBAI') }}
                                <div>
                            <span class="strong" style="padding-right: 60px;">

                            </span>

                                    Cidade:
                                    <span class="strong">
                                {{ value(documento.data, 'NOMECID') }}-{{ value(documento.data, 'UF') }}
                            </span>
                                </div>

                                <div>CEP:</div>

                                <div class="strong">
                                    {{ maskCEP(value(documento.data, 'CEP')) }}
                                </div>
                            </div>

                            <hr
                                    class="linha-divisoria"
                                    *ngIf="value(documento.data, 'PREFIXO') || value(documento.data, 'CERTIFICADO')">

                            <div
                                    class="info-grid-air"
                                    *ngIf="value(documento.data, 'PREFIXO') || value(documento.data, 'CERTIFICADO')">

                                <div style="min-height: 10px;"></div>

                                <div
                                        class="info-center-inline strong"
                                        *ngIf="value(documento.data, 'PREFIXO') || value(documento.data, 'CERTIFICADO')">

                            <span *ngIf="value(documento.data, 'PREFIXO')">
                                Prefixo:

                                <span
                                        style="padding-left: 5px;"
                                        class="strong">

                                    {{ value(documento.data, 'PREFIXO') }}
                                </span>
                            </span>

                                    <span
                                            class="info-inline-space"
                                            *ngIf="value(documento.data, 'PREFIXO') && value(documento.data, 'CERTIFICADO')">
                            </span>

                                    <span *ngIf="value(documento.data, 'CERTIFICADO')">
                                COM:

                                <span
                                        style="padding-left: 5px;"
                                        class="strong">

                                    {{ value(documento.data, 'CERTIFICADO') }}
                                </span>
                            </span>
                                </div>
                            </div>
                        </section>

                        <section
                                class="top-fields"
                                style="margin-top: 20px;">

                            <div class="meta-panel">
                                <div class="field-row">
                                    <span>Faturamento:</span>
                                    <strong>IMEDIATO</strong>
                                </div>

                                <div class="field-row">
                                    <span>Tipo:</span>
                                    <strong>
                                        {{ value(documento.data, 'GPL_TIPO') }}
                                    </strong>
                                </div>

                                <div class="field-row">
                                    <span>Condicao:</span>
                                    <strong>
                                        {{ value(documento.data, 'CONDICAO') }}
                                    </strong>
                                </div>

                                <div class="field-row">
                                    <span>Comprador:</span>
                                    <strong>COMERCIAL</strong>
                                </div>
                            </div>

                            <div class="meta-panel">
                                <div class="field-row">
                                    Prioridade:
                                    <strong>NORMAL</strong>
                                </div>

                                <div class="field-row">
                                    <span>Pre-venda(s):</span>
                                    <strong>-----</strong>
                                </div>

                                <div class="field-row">
                                    <span>Vendedor:</span>
                                    <strong>
                                        {{ firstTwoNames(value(documento.data, 'VENDEDOR')) }}
                                    </strong>
                                </div>

                                <div class="field-row">
                                    Emissao:
                                    <strong>
                                        {{ value(documento.data, 'DTATUAL') }}
                                    </strong>
                                </div>
                            </div>
                        </section>

                        <section
                                class="section-block"
                                *ngIf="visivel('IMP_FAT') && !mesmoClienteFaturadoEntrega(documento.data)"
                                style="padding-bottom: 20px">

                            <div class="section-title">
                                CLIENTE A SER FATURADO
                            </div>

                            <div style="min-height: 10px;"></div>

                            <div class="info-grid-nom">
                                <div>Cliente:</div>

                                <div class="strong cliente-faturado-identificacao">
                            <span class="cliente-faturado-codigo">
                                ({{ value(documento.data, 'CODPARC') || value(documento.data, 'CODCLIENTE') }}) -
                            </span>
                                    <span class="cliente-faturado-separador" aria-hidden="true"></span>
                                    <span class="cliente-faturado-nome">
                                {{ value(documento.data, 'NOMEPARC') }}
                            </span>
                                </div>

                                <div>e-mail:</div>

                                <div class="strong">
                                    {{
                                    documento.data?.EMAILPARC
                                    ? value(documento.data, 'EMAILPARC')
                                    : 'NÃO INFORMADO'
                                    }}
                                </div>
                            </div>

                            <div class="info-grid-doc">
                                <div>CPF/CNPJ:</div>

                                <div class="strong">
                                    {{ value(documento.data, 'CNPJ') }}
                                </div>

                                <div>IE:</div>

                                <div class="strong">
                                    {{
                                    documento.data?.INSCMUN
                                    ? value(documento.data, 'INSCMUN')
                                    : '----'
                                    }}
                                </div>
                            </div>

                            <div class="info-grid-end">
                                <div>Endereço:</div>

                                <div class="strong">
                                    {{ value(documento.data, 'NOMEEND') }}
                                </div>

                                <div>Fone:</div>

                                <div class="strong">
                                    {{ maskTelefone(value(documento.data, 'TELPARC')) }}
                                </div>
                            </div>

                            <div class="info-grid-ctt">
                                <div>Bairro:</div>

                                <div>
                            <span class="strong" style="padding-right: 60px;">
                                {{ value(documento.data, 'NOMEBAI') }}
                            </span>
                                    Cidade:
                                    <span class="strong">
                                {{ value(documento.data, 'NOMECID') }} - {{ value(documento.data, 'UF') }}
                            </span>
                                </div>

                                <div>CEP:</div>

                                <div class="strong">
                                    {{ maskCEP(value(documento.data, 'CEP')) }}
                                </div>
                            </div>

                            <hr
                                    class="linha-divisoria"
                                    *ngIf="value(documento.data, 'PREFIXO') || value(documento.data, 'CERTIFICADO')">

                            <div
                                    class="info-grid-air"
                                    *ngIf="value(documento.data, 'PREFIXO') || value(documento.data, 'CERTIFICADO')">

                                <div style="min-height: 10px;"></div>

                                <div class="info-center-inline strong">
                            <span *ngIf="value(documento.data, 'PREFIXO')">
                                Prefixo:

                                <span
                                        style="padding-left: 5px;"
                                        class="strong">

                                    {{ value(documento.data, 'PREFIXO') }}
                                </span>
                            </span>

                                    <span
                                            class="info-inline-space"
                                            *ngIf="value(documento.data, 'PREFIXO') && value(documento.data, 'CERTIFICADO')">
                            </span>

                                    <span *ngIf="value(documento.data, 'CERTIFICADO')">
                                COM:

                                <span
                                        style="padding-left: 5px;"
                                        class="strong">

                                    {{ value(documento.data, 'CERTIFICADO') }}
                                </span>
                            </span>
                                </div>
                            </div>
                        </section>

                        <section
                                class="section-block"
                                *ngIf="
                        visivel('IMP_ENT') &&
                        (entregaEndereco(documento.data) || '').trim() !==
                        (value(documento.data, 'NOMEEND') || '').trim()
                    ">

                            <div class="section-title">
                                {{ tituloEntrega(documento.data) }}
                            </div>

                            <div style="min-height: 10px;"></div>

                            <div class="info-grid-nom">
                                <div>Cliente:</div>

                                <div class="strong">
                                    {{ entregaCliente(documento.data) }}
                                </div>

                                <div>e-mail:</div>

                                <div class="strong">
                                    {{ entregaEmail(documento.data) || 'NÃO INFORMADO' }}
                                </div>
                            </div>

                            <div class="info-grid-doc">
                                <div>CPF/CNPJ:</div>

                                <div class="strong">
                                    {{ entregaDocumento(documento.data) }}
                                </div>

                                <div>IE:</div>

                                <div class="strong">
                                    {{ entregaIe(documento.data) || '----' }}
                                </div>
                            </div>

                            <div class="info-grid-end">
                                <div>Endereco:</div>

                                <div class="strong">
                                    {{ entregaEndereco(documento.data) }}
                                </div>

                                <div>Fone:</div>

                                <div class="strong">
                                    {{ entregaFone(documento.data) }}
                                </div>
                            </div>

                            <div class="info-grid-ctt entrega-info-grid">
                                <div>Bairro:</div>

                                <div>
                            <span class="strong" style="padding-right: 15px;">
                                {{ entregaBairro(documento.data) }}
                            </span>

                                    Cidade:

                                    <span class="strong">
                                {{ entregaCidadeUf(documento.data) }}
                            </span>
                                </div>

                                <div>CEP:</div>

                                <div class="strong">
                                    {{ entregaCep(documento.data) }}
                                </div>
                            </div>

                            <ng-container
                                    *ngIf="
                            mesmoClienteFaturadoEntrega(documento.data) &&
                            (
                                value(documento.data, 'PREFIXO') ||
                                value(documento.data, 'CERTIFICADO')
                            )
                        ">

                                <hr class="linha-divisoria">

                                <div class="info-grid-air">
                                    <div style="min-height: 10px;"></div>

                                    <div class="info-center-inline strong">
                                <span *ngIf="value(documento.data, 'PREFIXO')">
                                    Prefixo:

                                    <span style="padding-left: 5px;" class="strong">
                                        {{ value(documento.data, 'PREFIXO') }}
                                    </span>
                                </span>

                                        <span class="info-inline-space" *ngIf="value(documento.data, 'PREFIXO') && value(documento.data, 'CERTIFICADO')"></span>

                                        <span *ngIf="value(documento.data, 'CERTIFICADO')">
                                    COM:

                                    <span style="padding-left: 5px;" class="strong">
                                        {{ value(documento.data, 'CERTIFICADO') }}
                                    </span>
                                </span>
                                    </div>
                                </div>
                            </ng-container>

                            <div
                                    class="delivery-grid-transp"
                                    *ngIf="mostrarDadosEntregaTransporte(documento.data)">

                                <ng-container *ngIf="entregaTransportador(documento.data)">
                                    <div>Transp.:</div>

                                    <div class="strong">
                                        {{ entregaTransportador(documento.data) }}
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="entregaEnvio(documento.data)">
                                    <div>Envio:</div>

                                    <div class="strong">
                                        {{ entregaEnvio(documento.data) }}
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="entregaVolumes(documento.data)">
                                    <div>Volumes:</div>

                                    <div class="strong">
                                        {{ entregaVolumes(documento.data) }}
                                    </div>
                                </ng-container>
                            </div>
                        </section>

                        <section
                                class="observation-section"
                                *ngIf="value(documento.data, 'OBSVENDA')">

                            <div class="section-title section-title-framed">
                                Observação
                            </div>

                            <div class="observation-content">
                                {{ value(documento.data, 'OBSVENDA') }}
                            </div>
                        </section>

                        <div class="validity">
                            Validade do orcamento: 5 dias
                        </div>

                        <table class="items-table">

                            <!--
                                As larguras reais das colunas são controladas aqui.

                                A coluna Ord. passa a ter somente 38px e permanece
                                centralizada. A coluna Descrição recebe automaticamente
                                todo o espaço restante.
                            -->
                            <colgroup>
                                <col style="width: 38px;">

                                <col
                                        *ngIf="visivel('IMP_PN')"
                                        style="width: 105px;">

                                <col
                                        *ngIf="exibirColunaDescricao()">

                                <col style="width: 42px;">

                                <col
                                        *ngIf="visivel('IMP_VLR') && (visivel('IMP_DOL') || valoresEmDolar())"
                                        style="width: 82px;">

                                <col
                                        *ngIf="visivel('IMP_VLR') && !valoresEmDolar()"
                                        style="width: 82px;">

                                <col
                                        *ngIf="documento.possuiCoreAtual"
                                        style="width: 42px;">

                                <col
                                        *ngIf="documento.possuiCoreAtual && visivel('IMP_VLR')"
                                        style="width: 92px;">

                                <col
                                        *ngIf="exibirIpiDocumento(documento)"
                                        style="width: 58px;">

                                <col
                                        *ngIf="exibirStrDocumento(documento)"
                                        style="width: 58px;">

                                <col
                                        *ngIf="visivel('IMP_VLR')"
                                        style="width: 88px;">
                            </colgroup>

                            <thead>
                            <tr class="items-title-row">
                                <th
                                        [attr.colspan]="itemsTableColspan(documento)"
                                        class="items-title-cell">

                                    Lista de peças / produtos
                                </th>
                            </tr>

                            <tr>
                                <th class="col-ord" tabindex="0" data-ordenar-produtos="ord"
                                    [attr.aria-sort]="ordemProdutosAria('ord')" title="Ordenar por ordem do produto">
                                    Ord.
                                </th>

                                <th
                                        *ngIf="visivel('IMP_PN')"
                                        class="col-pn" tabindex="0" data-ordenar-produtos="partnumber"
                                        [attr.aria-sort]="ordemProdutosAria('partnumber')" title="Ordenar por Part Number">

                                    Part Number
                                </th>

                                <th
                                        *ngIf="exibirColunaDescricao()"
                                        class="col-desc" tabindex="0" data-ordenar-produtos="descricao"
                                        [attr.aria-sort]="ordemProdutosAria('descricao')" title="Ordenar por descrição">

                                    Descrição
                                </th>

                                <th class="col-qtd">
                                    Qtd.
                                </th>

                                <th
                                        *ngIf="visivel('IMP_VLR') && (visivel('IMP_DOL') || valoresEmDolar())"
                                        class="col-money" tabindex="0" data-ordenar-produtos="unitarioDolar"
                                        [attr.aria-sort]="ordemProdutosAria('unitarioDolar')" title="Ordenar por valor unitário em dólar">

                                    Valor UN. U$
                                </th>

                                <th
                                        *ngIf="visivel('IMP_VLR') && !valoresEmDolar()"
                                        class="col-money col-money-stack" tabindex="0" data-ordenar-produtos="unitarioReal"
                                        [attr.aria-sort]="ordemProdutosAria('unitarioReal')" title="Ordenar por valor unitário em reais">

                                    Valor UN. R$
                                </th>

                                <th
                                        *ngIf="documento.possuiCoreAtual"
                                        class="col-core">

                                    Core
                                </th>

                                <th
                                        *ngIf="documento.possuiCoreAtual && visivel('IMP_VLR')"
                                        class="col-money">

                                    {{ moedaTitulo('Valor Core') }}
                                </th>

                                <th
                                        *ngIf="exibirIpiDocumento(documento)"
                                        class="col-ipi">

                                    IPI. R$
                                </th>

                                <th
                                        *ngIf="exibirStrDocumento(documento)"
                                        class="col-str">

                                    ST. R$
                                </th>

                                <th
                                        *ngIf="visivel('IMP_VLR')"
                                        class="col-money col-total" tabindex="0" data-ordenar-produtos="total"
                                        [attr.aria-sort]="ordemProdutosAria('total')" title="Ordenar por total">

                                    {{ moedaTitulo('Total') }}
                                </th>
                            </tr>
                            </thead>

                            <tbody style="border: none !important;">
                            <ng-container
                                    *ngFor="
                                let item of itensOrdenados(documento);
                                let itemIndex = index
                            ">

                                <tr
                                        class="item-row"
                                        [class.item-valor-zerado]="item.valorSimbolicoZerado"
                                        [class.item-row-alt]="itemIndex % 2 === 1">

                                    <td
                                            class="col-ord"
                                            style="border-top: 1px solid #eef1f5;">

                                        {{ value(item, 'SEQUENCIA') }}
                                    </td>

                                    <td
                                            *ngIf="visivel('IMP_PN')"
                                            class="col-pn col-money-stack sub-left"
                                            style="border-top: 1px solid #eef1f5;">

                                        {{ value(item, 'REFFORN') }}
                                    </td>

                                    <td
                                            *ngIf="exibirColunaDescricao()"
                                            class="col-desc"
                                            style="border-top: 1px solid #eef1f5;">

                                        <ng-container *ngIf="visivel('IMP_DESC')">
                                            {{ value(item, 'DESCRPROD') }}<br/>
                                        </ng-container>
                                        <span
                                                class="item-fabricante"
                                                *ngIf="conteudoFabricanteCdItem(item) as fabricanteCd">
                                    ( {{ fabricanteCd }} )
                                </span>
                                    </td>

                                    <td
                                            class="col-qtd"
                                            style="border-top: 1px solid #eef1f5;">

                                        {{ value(item, 'QTDNEG') }}
                                    </td>

                                    <td
                                            *ngIf="visivel('IMP_VLR') && (visivel('IMP_DOL') || valoresEmDolar())"
                                            class="col-money"
                                            style="border-top: 1px solid #eef1f5;">

                                        {{ moneyVisual(valorUnitarioDolarVisual(item, documento.data)) }}
                                    </td>

                                    <td
                                            *ngIf="visivel('IMP_VLR') && !valoresEmDolar()"
                                            class="col-money col-money-stack"
                                            style="border-top: 1px solid #eef1f5;">

                                    <span class="item-money-main">
                                        {{ moneyVisual(valorUnitarioVisual(item, documento.data)) }}
                                    </span>
                                    </td>

                                    <td
                                            *ngIf="documento.possuiCoreAtual"
                                            class="col-core"
                                            style="border-top: 1px solid #eef1f5;">

                                        {{ value(item, 'CORE') }}
                                    </td>

                                    <td
                                            *ngIf="documento.possuiCoreAtual && visivel('IMP_VLR')"
                                            class="col-money"
                                            style="border-top: 1px solid #eef1f5;">

                                        {{ moneyVisual(valorCoreExibicao(item, documento.data)) }}
                                    </td>

                                    <td
                                            *ngIf="exibirIpiDocumento(documento)"
                                            class="col-ipi"
                                            style="border-top: 1px solid #eef1f5;">

                                        {{ moneyVisual(item.VLRIPI) }}
                                    </td>

                                    <td
                                            *ngIf="exibirStrDocumento(documento)"
                                            class="col-str"
                                            style="border-top: 1px solid #eef1f5;">

                                        {{ moneyVisual(item.VLRSUBST) }}
                                    </td>

                                    <td
                                            *ngIf="visivel('IMP_VLR')"
                                            class="col-money col-total"
                                            style="border-top: 1px solid #eef1f5;">

                                        {{ moneyVisual(totalItemExibicao(item, documento.data)) }}
                                    </td>
                                </tr>

                                <tr
                                        class="serial-row"
                                        [class.item-valor-zerado]="item.valorSimbolicoZerado"
                                        [class.item-row-alt]="itemIndex % 2 === 1"
                                        *ngIf="itemPossuiSerial(item)"
                                        style="border: none !important;">

                                    <td class="col-ord serial-empty"></td>

                                    <td
                                            [attr.colspan]="itemsTableColspan(documento) - 1"
                                            class="serial-cell serial-full"
                                            style="border-top: 0 !important;">

                                        <ng-container *ngIf="itemPossuiSerial(item)">
                                            <strong class="serial-title">
                                                Serial:
                                            </strong>

                                            <ng-container
                                                    *ngFor="
                                                let serial of seriaisItem(item);
                                                let primeiro = first
                                            ">

                                            <span
                                                    class="serial-separator"
                                                    *ngIf="!primeiro">
                                                |
                                            </span>

                                                <span class="serial-next">
                                                {{ serial }}
                                            </span>
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </tr>
                            </ng-container>
                            </tbody>
                        </table>

                        <section
                                class="totals"
                                [class.sem-core]="!documento.possuiCoreAtual">

                            <div
                                    class="core-note"
                                    *ngIf="documento.possuiCoreAtual">

                                <strong>Core</strong>

                                <span>
                            N = venda a base de troca, com devolucao da peca usada.
                        </span>

                                <span>
                            S = nao precisa devolver a peca, ja esta sendo cobrado o core.
                        </span>

                                <span>
                            Vazio = peca que nao possui core.
                        </span>
                            </div>

                            <div
                                    class="total-box"
                                    [class.sem-core]="!documento.possuiCoreAtual"
                                    *ngIf="visivel('IMP_VLR')">

                                <div class="total-row">
                                    <div class="total-label">
                                        {{ moedaTitulo('Total Peças') }}
                                    </div>

                                    <div class="num">
                                        {{ moneyVisual(totalPecasDocumento(documento.items, documento.data)) }}
                                    </div>
                                </div>

                                <div
                                        class="total-row"
                                        *ngIf="numeroMonetario(documento.data.VLRFRETE) !== 0">

                                    <div class="total-label">
                                        {{ moedaTitulo('Frete destinatário') }}
                                    </div>

                                    <div class="num">
                                        {{ moneyVisual(valorDocumentoExibicao(documento.data.VLRFRETE, documento.data)) }}
                                    </div>
                                </div>

                                <div
                                        class="total-row"
                                        *ngIf="
                                visivel('IMP_DES') &&
                                valorDescontoDocumentoExibicao(documento.data) !== 0
                            ">

                                    <div class="total-label">
                                        {{ moedaTitulo('Desconto') }}
                                    </div>

                                    <div class="num">
                                        {{ sinalDescontoDocumento(documento.data) }}
                                        {{ moneyVisual(valorDescontoDocumentoExibicao(documento.data)) }}
                                    </div>
                                </div>

                                <div
                                        class="total-row"
                                        *ngIf="totalCoreDocumento(documento.items, documento.data) !== 0">

                                    <div class="total-label">
                                        {{ moedaTitulo('Total Core') }}
                                    </div>

                                    <div class="num">
                                        {{
                                        moneyVisual(
                                        totalCoreDocumento(
                                        documento.items,
                                        documento.data
                                        )
                                        )
                                        }}
                                    </div>
                                </div>

                                <div
                                        class="total-row"
                                        *ngIf="exibirIpiDocumento(documento)">

                                    <div class="total-label">
                                        IPI R$
                                    </div>

                                    <div class="num">
                                        {{ moneyVisual(totalIpiDocumento(documento.items)) }}
                                    </div>
                                </div>

                                <div
                                        class="total-row"
                                        *ngIf="exibirStrDocumento(documento)">

                                    <div class="total-label">
                                        Substituição Tributária (ST) R$
                                    </div>

                                    <div class="num">
                                        {{ moneyVisual(totalStrDocumento(documento.items)) }}
                                    </div>
                                </div>

                                <div class="invoice-total">
                                    <div class="total-label">
                                        {{ moedaTitulo('Total Geral') }}
                                    </div>

                                    <div
                                            class="num"
                                            *ngIf="visivelTodos('IMP_VLR,IMP_TOT')">

                                        {{ moneyVisual(totalGeralDocumento(documento)) }}
                                    </div>
                                </div>
                            </div>
                        </section>


                        <section class="print-bottom-block">
                            <section class="payment-section">
                                <div class="section-title section-title-framed">
                                    Dados para pagamento
                                </div>

                                <div class="pix-container" [class.pix-container-three]="documento.contas.length === 3">
                                    <article
                                            class="pix-box"
                                            style="z-index: 700"
                                            *ngFor="let account of documento.contas">

                                        <div class="pix-qrcode">
                                            <img
                                                    *ngIf="account.imagem"
                                                    [src]="account.imagem"
                                                    alt="QR Code PIX">

                                            <div
                                                    *ngIf="!account.imagem"
                                                    class="qr-box"
                                                    aria-label="QR Code PIX indisponivel">
                                            </div>
                                        </div>

                                        <div class="pix-dados">
                                            <strong>
                                                <img *ngIf="iconeBanco(account) as icone" class="pix-bank-icon"
                                                     [src]="icone" alt="" aria-hidden="true">
                                                {{ ultimaPalavraDeposito(account) }}
                                            </strong>

                                            <p>
                                                AG: {{ account.conta || account.CONTA }}
                                            </p>

                                            <p>
                                                Favorecido:
                                                {{ account.favorecido || account.FAVORECIDO }}
                                            </p>

                                            <p>
                                                CNPJ:
                                                {{ account.cnpj || account.CNPJ }}
                                            </p>

                                        </div>

                                        <p class="pix-chave">
                                            Chave PIX:
                                            <strong>{{ account.pix || account.PIX }}</strong>
                                        </p>
                                    </article>
                                </div>
                            </section>

                            <footer class="footer">
                                <div class="footer-code">
                                    <div>
                                        {{ value(documento.data, 'CODEMP') }}
                                    </div>

                                    <div>
                                        {{ nunotaFormatado(documento.data) }}
                                    </div>
                                </div>

                                <div class="center">
                                    <div>
                                        AV. DOS INDIOS N 352, QD 124, LT 38 - SANTA GENOVEVA - CEP 74.672-450 - GOIANIA - GO{{
                                        value(documento.data, 'ENDEMPRESA') }}
                                    </div>

                                    <div>
                                <span>

                                    Fone(s): (62) 3207-1414 - (62) 3207-1413 -
                                    <!--  {{ value(documento.data, 'TELEFONEEMP') }} -->
                                    -
                                </span>

                                        www.globalp.com.br

                                        <span>
                                    - email:
                                    {{ value(documento.data, 'EMAILUSULOGADO') || 'leonardo@globalp.com.br' }}
                                </span>
                                    </div>
                                </div>

                                <div class="footer-page">
                                    <div data-page-counter></div>
                                    <div>{{ documento.printDate }}</div>
                                </div>
                            </footer>
                        </section>

                    </section>
                </main>
            </div>
            <p class="pagination-error" *ngIf="erroPaginacao()" role="alert">{{ erroPaginacao() }}</p>
            <div class="print-pages paginated-pages" [style.zoom]="vendaZoomAtual"></div>
        </ng-container>



        <dialog
                #modalItensZerados
                class="modal-confirmacao-impressao no-print"
                role="alertdialog"
                aria-labelledby="tituloConfirmacaoImpressao"
                aria-describedby="mensagemConfirmacaoImpressao"
                (cancel)="cancelarImpressaoItensZerados()">

            <div class="modal-confirmacao-shell">

                <div class="modal-confirmacao-header">
                    <h2 id="tituloConfirmacaoImpressao">Atenção !</h2>
                </div>

                <div class="modal-confirmacao-body">
                    <p id="mensagemConfirmacaoImpressao">
                        Existe 1 ou mais itens zerados !!<br >
                        Deseja realmente
                        {{ acaoPendenteItensZerados === 'pdf'
                        ? 'gerar o PDF'
                        : 'imprimir' }} ?
                    </p>
                </div>

                <div class="modal-confirmacao-footer">

                    <button
                            type="button"
                            class="botao-confirmar"
                            (click)="confirmarImpressaoItensZerados()">
                        {{ acaoPendenteItensZerados === 'pdf'
                        ? 'Gerar PDF'
                        : 'Imprimir' }}
                    </button>

                    <button
                            type="button"
                            class="botao-cancelar"
                            (click)="cancelarImpressaoItensZerados()">
                        Cancelar
                    </button>

                </div>

            </div>
        </dialog>
    </main>
</div>
